import baseApi from '@/store/api/baseApi';

// CORS Anywhere proxy for development only
// const CORS_PROXY = 'https://cors-anywhere.herokuapp.com/';
// const SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';

export const slackWebhook = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		bugReportToSlack: builder.mutation({
			query: ({ body }) => ({
				url: `/integration/slack/bug-report`, // Using CORS proxy for testing
				method: 'POST',
				body
			})
		})
	})
});

export const { useBugReportToSlackMutation } = slackWebhook;
